import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GasPlantAdminService } from '../../services/gas-plant-admin.service';
import { ErrorHandler } from '../../utils/error-handler';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import {adminDeleteRequest,adminDropdownFilters,adminInsertUpdateRequest,adminTableData,adminDropdownoptions} from '../../services/interfaces/gas-plant-admin.interfaces';
import {subDevAreaTableData,subDevAreaDropdownOptions,subDevAreaDeleteRequest,subDevAreaFilterDropdowns,subDevAreaInsertUpdateRequest} from '../../services/interfaces/sub-dev-area.interface';
import { exportRowsToExcel } from '../../utils/excel-export';

@Component({
  selector: 'app-gas-plant-mapping',
  standalone: false,
  templateUrl: './gas-plant-mapping.component.html',
  styleUrls: ['./gas-plant-mapping.component.scss'],
})
export class GasPlantMappingComponent implements OnInit {
  private readonly blankFilterToken = 'NULL';

  spinnerBoolean: boolean = false;
  data: any[] = [];
  selectedRows: any[] = [];
  expandedTable: string | null = null;
  dataSubDevArea: any[] = [];
  lastSubDevRowNumber: number = 0;
  allSubDevRowsLoaded: boolean = false;
  subDevSpinnerBoolean: boolean = false;
  devAreaOptions: string[] = [];
  facilityNameOptions: string[] = [];
  facilityTypeOptions: string[] = [];
  oilTakeAwayOptions: string[] = [];
  gasTakeAwayOptions: string[] = [];
  padNameOptions: string[] = [];
  subDevAreaOptions: string[] = [];
  availablePadOptions: { [rowId: string]: string[] } = {};
  priorityOptions: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  editablePriorityOptions: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  columns = [
    {field: 'developmentArea',header: 'Dev Area',editable: (row: any) => row.isNew, required: true,},
    {field: 'facilityType',header: 'Facility Type',editable: (row: any) => row.isNew,required: true,},
    { field: 'facilityName',header: 'Facility Name',editable: true,required: true,},
    { field: 'oilTakeAway', header: 'Oil TakeAway', editable: (row: any) => row.isNew, required: true },
    { field: 'gasTakeAway', header: 'Gas TakeAway', editable: (row: any) => row.isNew, required: true },
    {field: 'priority',header: 'Priority',editable: (row: any) => row.isNew,required: true,},
  ];
  allRowsLoaded: boolean = false;
  lastRowNumber: number = 0;
  dropdownPosition: { top: number; left: number } = { top: 0, left: 0 };
  activeFilter: string = '';
  activeFilterTable: 'admin' | 'subDev' | null = null;
  showFloatingFilter: boolean = false;
  multiFilters: { [key: string]: string[] } = {};  subDevMultiFilters: { [key: string]: string[] } = {};
  isLoadingFilterOptions: boolean = false;
  isLoadingSubDevFilterOptions: boolean = false;
  filterSearch: { [key: string]: string } = {};
  @ViewChild('deleteConfirmDialog') deleteConfirmDialog!: TemplateRef<any>;
  @ViewChild('adminExportOptionsDialog') adminExportOptionsDialog!: TemplateRef<any>;
  @ViewChild('subDevExportOptionsDialog') subDevExportOptionsDialog!: TemplateRef<any>;
  dialogMessage: string = '';
  constructor(
    private toastr: ToastrService,
    private gasPlantAdminService: GasPlantAdminService,
    private http: HttpClient,
    private authService: AuthService,
    private dialog: MatDialog
  ) {}
  ngOnInit() {
    this.loadDropdowns();
    this.loadSubDevAreaDropdowns(null);
    this.loadTableData();
    this.loadSubDevAreaData();
  }

  loadSubDevAreaData(lastRowNumber: number = 0) {
    if (lastRowNumber === 0) {
      this.dataSubDevArea = [];
      this.lastSubDevRowNumber = 0;
      this.allSubDevRowsLoaded = false;
    }
    const filters:subDevAreaTableData = {
      developmentArea: null,
      subDevAreaName: null,
      padName: null,
      lastRowNumber: lastRowNumber,};
    this.gasPlantAdminService.getSubDevAreaData(filters).subscribe(
      (response: any) => { if (!response) {return;}
        const parsed = ErrorHandler.parseApiResult(response);
        if ( parsed.success && Array.isArray(response.subDevAreaDetails)) {
          const mappedData = response.subDevAreaDetails.map((item: any) => {
          const padRaw = item.padName ?? item.PadName ?? null;
          const padList = this.parseSubDevPadNames(padRaw);
            return {
              _rowId: this.generateRowId(),
              devArea: item.developmentArea,
              subDevArea: item.subDevAreaName,
              padName: padList,
              isNew: false,
              _rowEdited: false,
              original: {subDevArea: item.subDevAreaName,padName: [...padList],},
            };
          });
          this.dataSubDevArea =lastRowNumber === 0 ? mappedData : [...this.dataSubDevArea, ...mappedData];
          this.lastSubDevRowNumber = response.nextRowNumber;
          if (response.nextRowNumber) {
            this.loadSubDevAreaData(response.nextRowNumber);  }
          if (response.nextRowNumber === 2 || response.nextRowNumber === undefined) this.allSubDevRowsLoaded = true;
        } else if (Array.isArray(response.rows)) {
          const mappedData = response.rows.map((item: any) => ({ ...item }));
          this.dataSubDevArea =lastRowNumber === 0? mappedData: [...this.dataSubDevArea, ...mappedData];
          this.lastSubDevRowNumber = response.nextRowNumber;
          if (response.nextRowNumber) {
            this.loadSubDevAreaData(response.nextRowNumber);}
          if (response.nextRowNumber === null || response.nextRowNumber === undefined)this.allSubDevRowsLoaded = true;}
      },
      (error) => {
        ErrorHandler.handleError(error, 'loadSubDevAreaData');
      }
    );
  }

  private parseSubDevPadNames(padRaw: unknown): string[] {
    if (Array.isArray(padRaw)) {
      return padRaw
        .map((pad) => (typeof pad === 'string' ? pad.trim() : ''))
        .filter(Boolean);
    }

    if (typeof padRaw !== 'string') {
      return [];
    }

    if (!padRaw.includes('-')) {
      const trimmedPad = padRaw.trim();
      return trimmedPad ? [trimmedPad] : [];
    }

    return padRaw
      .split('-')
      .map((pad) => pad.trim())
      .filter(Boolean);
  }

  private serializeSubDevPadNames(pads: unknown): string[] {
    const normalizedPads = Array.isArray(pads)
      ? pads
          .map((pad) => (typeof pad === 'string' ? pad.trim() : ''))
          .filter(Boolean)
      : this.parseSubDevPadNames(pads);

    return normalizedPads.length ? [normalizedPads.join('-')] : [];
  }

  private isBlankFilterValue(value: unknown): boolean {
    if (value === null || value === undefined) {
      return true;
    }

    const normalized = String(value).trim();
    return normalized === '' || normalized.toLowerCase() === 'null';
  }

  private normalizeFilterOptionValue(value: unknown): string {
    if (this.isBlankFilterValue(value)) {
      return this.blankFilterToken;
    }

    return String(value).trim();
  }

  private normalizeFilterOptionList(values: unknown[]): string[] {
    const normalizedValues = Array.from(
      new Set(values.map((value) => this.normalizeFilterOptionValue(value)))
    );

    const blankIndex = normalizedValues.indexOf(this.blankFilterToken);
    if (blankIndex > 0) {
      normalizedValues.splice(blankIndex, 1);
      normalizedValues.unshift(this.blankFilterToken);
    }

    return normalizedValues;
  }

 loadDropdowns(
  filters: adminDropdownoptions = {
    developmentArea: null,
    facilityName: null,
      gasTakeAway: null,
      oilTakeAway: null,
    facilityType: null,
  }
) {
  this.gasPlantAdminService.getDropdownOptions(filters).subscribe(
    (response: any) => {
      const items: any[] = Array.isArray(response)
        ? response
        : response?.adminColumnFilterItems || response?.columnFilterItems || response?.filterItems || [];
      const devAreas: string[] = [];
      const subDevAreas: string[] = [];
      const facilityNames: string[] = [];
      const facilityTypes: string[] = [];
      const oilTakeAways: string[] = [];
      const gasTakeAways: string[] = [];
      if (Array.isArray(items)) {
        items.forEach((item: any) => {
          const key = this.normalizeColumnName(item?.columnName || item?.ColumnName || '');
          const vals = this.toStringList(item?.values ?? item?.Values ?? []);

          if (key === 'developmentarea' || key === 'devarea') {
            devAreas.push(...vals);
          } else if (key === 'subdevelopmentarea' || key === 'subdevarea' || key === 'subdevareaname') {
            subDevAreas.push(...vals);
          } else if (key === 'facilityname') {
            facilityNames.push(...vals);
          } else if (key === 'facilitytype') {
            facilityTypes.push(...vals);
          } else if (key === 'oiltakeaway') {
            oilTakeAways.push(...vals);
          } else if (key === 'gastakeaway') {
            gasTakeAways.push(...vals);
          }
        });
      }
      // Deduplicate and assign options
      this.devAreaOptions = Array.from(new Set(devAreas)).filter(Boolean);
      this.subDevAreaOptions = Array.from(new Set(subDevAreas)).filter(Boolean);
      this.facilityNameOptions = Array.from(new Set(facilityNames)).filter(
        Boolean
      );
      this.facilityTypeOptions = Array.from(new Set(facilityTypes)).filter(Boolean);
      this.oilTakeAwayOptions = this.normalizeFilterOptionList(oilTakeAways);
      this.gasTakeAwayOptions = this.normalizeFilterOptionList(gasTakeAways);
    },
    (error) => {
      this.toastr.error('Failed to load dropdown options.');
    }
  );
}

  onDropdownChange(row?: any) {
    const sourceRow = row ?? this.data[0] ?? {};
    if (this.shouldDisableOilTakeAway(sourceRow)) {
      sourceRow.oilTakeAway = '';
    }
    if (this.shouldDisableGasTakeAway(sourceRow)) {
      sourceRow.gasTakeAway = '';
    }
    const filters: adminDropdownoptions = {
      developmentArea: sourceRow.devArea || null,
      facilityName: sourceRow.facilityName || null,
      gasTakeAway: sourceRow.gasTakeAway || null,
      oilTakeAway: sourceRow.oilTakeAway || null,
      facilityType: sourceRow.facilityType || null,
    };
    this.loadDropdowns(filters);
  }

  loadSubDevAreaDropdowns(developmentArea: string | null) {
    const requestBody: subDevAreaDropdownOptions = { developmentArea: developmentArea, padName: null };
    this.gasPlantAdminService.getSubDevAreaDropdownOptions(requestBody).subscribe(
      (response: any) => {
        if (response && response.statusCode === 200 && response.subDevAreaColumnFilterItems) {
          response.subDevAreaColumnFilterItems.forEach((item: any) => {
            if (item.columnName === 'DevelopmentArea') {
              this.devAreaOptions = item.values || [];
            } else if (item.columnName === 'PadName') {
              this.padNameOptions = item.values || [];
            }
          });
        } else {
          ErrorHandler.handleError(new Error('Failed to load sub-dev area options (unexpected response).'), 'loadSubDevAreaDropdowns');
        }
      },
      (error) => {
        ErrorHandler.handleError(error, 'loadSubDevAreaDropdowns');
      }
    );
  }

  onSubDevRowDevAreaChange(row: any) {
    const devArea = row.devArea || null;
    const requestBody: subDevAreaDropdownOptions = { developmentArea: devArea, padName: null };
    this.gasPlantAdminService.getSubDevAreaDropdownOptions(requestBody).subscribe(
        (response: any) => {
          if (response && response.statusCode === 200 && response.subDevAreaColumnFilterItems) {
              let pads: string[] = [];
              response.subDevAreaColumnFilterItems.forEach((item: any) => {
                if (item.columnName === 'PadName') {
                  pads = item.values || [];
                }
              });
              this.availablePadOptions[row._rowId] = pads;
              if (row.padName && row.padName.length) {
                row.padName = row.padName.filter((p: string) => pads.includes(p));
                this.handleEdit(row);
              }
            } else {
              ErrorHandler.handleError(new Error('Failed to reload pad options for selected Dev Area (unexpected response).'), 'onSubDevRowDevAreaChange');
            }
          },
          (error) => {
            ErrorHandler.handleError(error, 'onSubDevRowDevAreaChange');
          }
        );
  }

  addRow() {
    const newRow = {
      _rowId: this.generateRowId(),
      devArea: '',
      facilityType: '', 
      facilityName: '',
      oilTakeAway: '',
      gasTakeAway: '',
      priority: '',
      isNew: true,
      _rowEdited: false,
      original: {},
      facilityTypeOptions: [],
    };
    this.loadDropdowns();
    const component = this;
    Object.defineProperty(newRow, 'facilityType', {
      set: function (value) {
        this._facilityType = value;
        if (component.shouldDisableOilTakeAway(this)) {
          this.oilTakeAway = '';
        }
        if (component.shouldDisableGasTakeAway(this)) {
          this.gasTakeAway = '';
        }
        if (component.isCdpFacilityType(value)) {
          this.priority = 0;
        }
      },
      get: function () {
        return this._facilityType;
      },
    });
    this.data.unshift(newRow);
    this.toastr.info('New row added. Please fill in the details.');
  }

  addNewSubDevAreaRow() {
    const newRow = {
      _rowId: this.generateRowId(),
      devArea: '',
      subDevArea: '',
      padName: [],
      isNew: true,
      _rowEdited: false,
      original: {},
    };
    this.loadSubDevAreaDropdowns(null);
    this.dataSubDevArea.unshift(newRow);
    this.toastr.info('New row added to Sub-Dev Area Mapping. Please fill in the details.');
  }

  handleSave() {
    const changedRows = this.data.filter((row) => {
      if (row.isNew) return true;
      const hasFacilityNameChanged =
        row.facilityName !== row.originalFacilityName;
      const hasPriorityChanged =
        Number(row.priority) !== Number(row.originalPriority);
      if (hasFacilityNameChanged || hasPriorityChanged) {
        row._rowEdited = true;
      }
      return hasFacilityNameChanged || hasPriorityChanged;
    });
    if (!changedRows.length) {
      this.toastr.info('No new or modified rows to save.');
      return;
    }
    let successCount = 0;
    let failureCount = 0;
    const errorMessages: string[] = [];
    let pendingCount = changedRows.length;

    changedRows.forEach((row) => {
      const action = row.isNew ? 'insert' : 'update';
      const requestBody: adminInsertUpdateRequest = {
        action: action,
        developmentArea: row.devArea,
        oldFacilityName: row.isNew ? null : row.originalFacilityName,
        facilityName: row.facilityName,
        gasTakeAway: row.gasTakeAway || null,
        oilTakeAway: row.oilTakeAway || null,
        facilityType: row.facilityType,
        priority: row.priority,
        oldPriority: row.isNew ? null : row.originalPriority,
        userName: this.authService.getUserEmail(),
      };
      this.gasPlantAdminService.insertUpdateRecord(requestBody).subscribe(
        (response: any) => {
          const parsed = ErrorHandler.parseApiResult(response);
          if (parsed.success) {
            row.isNew = false;
            row._rowEdited = false;
            row.originalFacilityName = row.facilityName;
            row.originalPriority = row.priority;
            successCount++;
          } else {
            failureCount++;
            errorMessages.push(parsed.message || 'Unknown error occurred');
          }
          pendingCount--;
          if (pendingCount === 0) {
            this.loadTableData();
            const detailedErrorMsg =
              errorMessages.length > 0
                ? errorMessages.join('<br>')
                : `${failureCount} row(s) failed to save`;
            ErrorHandler.showCrudToasterByStatus(
              {
                statusCode: failureCount > 0 ? 400 : 200,
                statusMessage: failureCount > 0 ? detailedErrorMsg : `${successCount} row(s) saved successfully`,
              },
              this.toastr,
              `${successCount} row(s) saved successfully`,
              detailedErrorMsg,
              { timeOut: 8000, enableHtml: true }
            );
          }
        },
        (error: any) => {
          const parsed = ErrorHandler.parseApiResult(error);
          failureCount++;
          errorMessages.push(parsed.message || 'Unknown error occurred');
          pendingCount--;
          if (pendingCount === 0) {
            this.loadTableData();
            const detailedErrorMsg =
              errorMessages.length > 0
                ? errorMessages.join('<br>')
                : `${failureCount} row(s) failed to save`;
            ErrorHandler.showCrudToasterByStatus(
              {
                statusCode: failureCount > 0 ? 400 : 200,
                statusMessage: failureCount > 0 ? detailedErrorMsg : `${successCount} row(s) saved successfully`,
              },
              this.toastr,
              `${successCount} row(s) saved successfully`,
              detailedErrorMsg,
              { timeOut: 8000, enableHtml: true }
            );
          }
        }
      );
    });
  }

  handleDelete() {
    if (!this.selectedRows.length) {
      this.toastr.info('Please select rows to delete.');
      return;
    }
    const dialogRef = this.dialog.open(this.deleteConfirmDialog, {
      width: '400px',
      data: { message: `Are you sure you want to delete ${this.selectedRows.length} row(s)?`,},
    });
    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return;
      let successCount = 0;
      let failureCount = 0;
      const errorMessages: string[] = [];
      let pendingCount = this.selectedRows.length;

      this.selectedRows.forEach((row) => {
        const requestBody: adminDeleteRequest = {
          developmentArea: row.devArea,
          facilityName: row.facilityName,
          gasTakeAway: row.gasTakeAway || null,
          oilTakeAway: row.oilTakeAway || null,
          facilityType: row.facilityType,
          priority: row.priority,
        };
        this.gasPlantAdminService.deleteOilAndGasDetails(requestBody).subscribe(
          (response: any) => {
              const parsed = ErrorHandler.parseApiResult(response);
              const isSuccess =
                parsed.success ||
                response?.error === false ||
                response?.statusCode === 200 ||
                response?.status === 200;
              if (isSuccess) {
                this.data = this.data.filter((r) => r !== row);
                const idx = this.selectedRows.indexOf(row);
                if (idx > -1) this.selectedRows.splice(idx, 1);
                successCount++;
              } else {
                failureCount++;
                errorMessages.push(parsed.message || 'Unknown error occurred');
              }
              pendingCount--;
              if (pendingCount === 0) {
                this.loadTableData();
                const detailedErrorMsg =
                  errorMessages.join('<br>') || `${failureCount} row(s) failed to delete`;
                ErrorHandler.showCrudToasterByStatus(
                  {
                    statusCode: failureCount > 0 ? 400 : 200,
                    statusMessage: failureCount > 0 ? detailedErrorMsg : `${successCount} row(s) deleted successfully.`,
                  },
                  this.toastr,
                  `${successCount} row(s) deleted successfully.`,
                  detailedErrorMsg,
                  { timeOut: 8000, enableHtml: true }
                );
              }
            },
            (error: any) => {
              const parsed = ErrorHandler.parseApiResult(error);
              const isSuccess =
                parsed.success ||
                error?.statusCode === 200 ||
                error?.status === 200;
              if (isSuccess) {
                this.data = this.data.filter((r) => r !== row);
                const idx = this.selectedRows.indexOf(row);
                if (idx > -1) this.selectedRows.splice(idx, 1);
                successCount++;
              } else {
                failureCount++;
                errorMessages.push(parsed.message || 'Unknown error occurred');
              }
              pendingCount--;
              if (pendingCount === 0) {
                this.loadTableData();
                const detailedErrorMsg =
                  errorMessages.join('<br>') || `${failureCount} row(s) failed to delete`;
                ErrorHandler.showCrudToasterByStatus(
                  {
                    statusCode: failureCount > 0 ? 400 : 200,
                    statusMessage: failureCount > 0 ? detailedErrorMsg : `${successCount} row(s) deleted successfully.`,
                  },
                  this.toastr,
                  `${successCount} row(s) deleted successfully.`,
                  detailedErrorMsg,
                  { timeOut: 8000, enableHtml: true }
                );
              }
            }
          );
      });
    });
  }

  handleSubDevDelete() {
    const selectedSubDevRows = this.selectedRows.filter((r) =>this.dataSubDevArea.includes(r) );
    if (!selectedSubDevRows.length) {
      this.toastr.info('Please select Sub-Dev rows to delete.');
      return;
    }
    const dialogRef = this.dialog.open(this.deleteConfirmDialog, {
      width: '400px',
      data: { message: `Are you sure you want to delete ${selectedSubDevRows.length} Sub-Dev row(s)?`,},
    });
    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return;
      let successCount = 0;
      let failureCount = 0;
      const errorMessages: string[] = [];
      let pendingCount = selectedSubDevRows.length;

      selectedSubDevRows.forEach((row) => {
        const requestBody: subDevAreaDeleteRequest = {
          developmentArea: row.devArea,
          subDevAreaName: row.subDevArea,
          user: this.authService.getUserEmail(),
        };
        this.gasPlantAdminService.subDevAreaDeleteOilAndGasDetails(requestBody).subscribe(
          (response: any) => {
              const parsed = ErrorHandler.parseApiResult(response);
              if (parsed.success) {
                this.dataSubDevArea = this.dataSubDevArea.filter((r) => r !== row);
                const idx = this.selectedRows.indexOf(row);
                if (idx > -1) this.selectedRows.splice(idx, 1);
                successCount++;
              } else {
                failureCount++;
                errorMessages.push(parsed.message || 'Unknown error occurred');
              }
              pendingCount--;
              if (pendingCount === 0) {
                this.loadSubDevAreaData();
                if (successCount > 0) {
                  this.toastr.success(`${successCount} Sub-Dev row(s) deleted successfully.`);
                }
                if (failureCount > 0) {
                  this.toastr.error(errorMessages.join('<br>') || `${failureCount} Sub-Dev row(s) failed to delete`, 'Delete Error', {
                    timeOut: 8000,
                    enableHtml: true
                  });
                }
              }
            },
            (error: any) => {
              const parsed = ErrorHandler.parseApiResult(error);
              failureCount++;
              errorMessages.push(parsed.message || 'Unknown error occurred');
              pendingCount--;
              if (pendingCount === 0) {
                this.loadSubDevAreaData();
                if (successCount > 0) {
                  this.toastr.success(`${successCount} Sub-Dev row(s) deleted successfully.`);
                }
                if (failureCount > 0) {
                  this.toastr.error(errorMessages.join('<br>') || `${failureCount} Sub-Dev row(s) failed to delete`, 'Delete Error', {
                    timeOut: 8000,
                    enableHtml: true
                  });
                }
              }
            }
          );
      });
    });
  }

  cancelAdminChanges(): void {
    this.data = this.data.filter((row) => {if (row.isNew) return false; 
      if (row._rowEdited) {
        if (row.originalFacilityName !== undefined) row.facilityName = row.originalFacilityName;
        if (row.originalPriority !== undefined) row.priority = row.originalPriority;
        row._rowEdited = false;
      }
      return true;
    });
    this.selectedRows = this.selectedRows.filter((r) => !this.data.includes(r));
    this.toastr.info('Admin changes cancelled.');
  }

  cancelSubDevChanges(): void {
    this.dataSubDevArea = this.dataSubDevArea.filter((row) => {if (row.isNew) return false; 
      if (row._rowEdited) {
        if (row.original && row.original.subDevArea !== undefined) row.subDevArea = row.original.subDevArea;
        if (row.original && row.original.padName !== undefined) row.padName = [...row.original.padName];
        row._rowEdited = false;
      }
      return true;
    });
    this.selectedRows = this.selectedRows.filter((r) => !this.dataSubDevArea.includes(r));
    this.toastr.info('Sub-Dev changes cancelled.');
  }

  toggleRowSelection(row: any, event: any) {
    if (event.target.checked) {
      if (!this.selectedRows.includes(row)) {
        this.selectedRows.push(row);
      }
    } else {
      const index = this.selectedRows.indexOf(row);
      if (index > -1) {
        this.selectedRows.splice(index, 1);
      }
    }
  }

  handleEdit(row: any) {
    const editableFields = this.columns
      .filter((col) =>typeof col.editable === 'function' ? col.editable(row) : col.editable).map((col) => col.field);
    if (row.isNew && Object.keys(row).some((key) => editableFields.includes(key))) {
      row._rowEdited = true;
    }
  }

  generateRowId(): string {
    return `row_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  toggleExpand(table: string): void {
    this.expandedTable = this.expandedTable === table ? null : table;
  }

  removePad(row: any, pad: string): void {
    const index = row.padName.indexOf(pad);
    if (index > -1) {
      row.padName.splice(index, 1);
      this.handleSubDevEdit(row);
    }
  }


  padSearch: { [rowId: string]: string } = {};
  activePadDropdownRowId: string | null = null;
  padDropdownPosition: { top: number; left: number } = { top: 0, left: 0 };
  private padDropdownOutsideClickHandler: any = null;
  private padDropdownOpeningElement: HTMLElement | null = null;
  private filterOutsideClickHandler: any = null;

  getFilteredPadOptions(row: any): string[] {
    const search = (this.padSearch[row._rowId] || '').toLowerCase();
    const sourceOptions: string[] = this.availablePadOptions[row._rowId] || this.padNameOptions;
    if (!search) {
      return sourceOptions.slice(0, 2000);
    }
    return sourceOptions.filter((opt) => opt.toLowerCase().includes(search));
  }

  openPadDropdown(
    row: any,
    event: Event | MouseEvent,
    inputElement: HTMLElement
  ) {
    const potentialTarget =inputElement || (event && (event.target as HTMLElement));
    if (this.activePadDropdownRowId !== row._rowId) {
      this.activePadDropdownRowId = row._rowId;
      const targetEl =potentialTarget instanceof HTMLElement ? potentialTarget: document.body;
      const rect = targetEl && (targetEl as HTMLElement).getBoundingClientRect ? (targetEl as HTMLElement).getBoundingClientRect(): { bottom: 0, left: 0 };
      this.padDropdownPosition = { top: rect.bottom + 4, left: rect.left };
    }
    if (!this.padSearch[row._rowId]) this.padSearch[row._rowId] = '';
    if (!this.padDropdownOutsideClickHandler) {
      this.padDropdownOpeningElement =potentialTarget instanceof HTMLElement ? potentialTarget : null;
      this.padDropdownOutsideClickHandler = (e: MouseEvent) => {
        const target = e.target as HTMLElement;
        const panel = document.querySelector('.pad-dropdown-panel');
        if (panel && panel.contains(target)) return;
        if (this.padDropdownOpeningElement &&this.padDropdownOpeningElement.contains(target))
          return;
        if (panel && !panel.contains(target)) {
          this.closePadDropdown();}
      };
      setTimeout(() =>
        document.addEventListener('click', this.padDropdownOutsideClickHandler)
      );
    }
  }

  closePadDropdown() {
    this.activePadDropdownRowId = null;
    if (this.padDropdownOutsideClickHandler) {
      document.removeEventListener( 'click', this.padDropdownOutsideClickHandler);
      this.padDropdownOutsideClickHandler = null;
      this.padDropdownOpeningElement = null;
    }
  }

  confirmAddPad(row: any, pad: string) {
    if (!row.padName) row.padName = [];
    if (!row.padName.includes(pad)) {
      row.padName.push(pad);
      this.handleEdit(row);
    }
  }

  handlePadInputEnter(event: Event, row: any) {
    const ke = event as KeyboardEvent;
    if (ke.preventDefault) ke.preventDefault();
    const searchValue = (this.padSearch[row._rowId] || '').trim();
    if (!searchValue) return;
    const options = this.getFilteredPadOptions(row);
    const matched = options.find((o) => o.toLowerCase() === searchValue.toLowerCase());
    if (matched) {
      if (row.padName && row.padName.includes(matched)) {
        this.toastr.info('Pad already selected.');
      } else {
        this.confirmAddPad(row, matched);
      }
      this.padSearch[row._rowId] = '';
      this.closePadDropdown();
      return;
    }
    if (row.padName && row.padName.some((p: string) => p.toLowerCase() === searchValue.toLowerCase())) {
      this.toastr.info('Pad already selected.');
      return;
    }
    if (!row.padName) row.padName = [];
    row.padName.push(searchValue);
    this.handleEdit(row);
    this.padSearch[row._rowId] = '';
    this.closePadDropdown();
  }

  handleSubDevEdit(row: any) {if (!row.isNew && !row._rowEdited) row._rowEdited = true;}

  handleSubDevSave() {
    const changedRows = this.dataSubDevArea.filter((row) => {if (row.isNew) return true;
      const subDevChanged =row.subDevArea !== (row.original?.subDevArea ?? row.subDevArea);
      const padChanged =JSON.stringify(row.padName || []) !==JSON.stringify(row.original?.padName || []);
      if (subDevChanged || padChanged) row._rowEdited = true;
      return subDevChanged || padChanged;
    });
    if (!changedRows.length) {this.toastr.info('No new or modified Sub-Dev Area rows to save.');
      return;
    }
    let successCount = 0;
    let failureCount = 0;
    const errorMessages: string[] = [];
    let pendingCount = changedRows.length;

    changedRows.forEach((row) => {
      const action = row.isNew ? 'insert' : 'update';
      const subDevChanged = row.isNew || row.subDevArea !== (row.original?.subDevArea ?? row.subDevArea);
      const oldSubDevAreaName = !row.isNew && subDevChanged ? (row.original?.subDevArea || null) : null;

      const padListToSend = this.serializeSubDevPadNames(row.padName);

      const requestBody: subDevAreaInsertUpdateRequest = {
        action: action,
        developmentArea: row.devArea,
        subDevAreaName: row.subDevArea,
        oldSubDevAreaName: oldSubDevAreaName,
        padList: padListToSend,
        user: this.authService.getUserEmail(),
      };
      this.gasPlantAdminService.subDevAreaInsertUpdateRecord(requestBody).subscribe(
        (response: any) => {
          const parsed = ErrorHandler.parseApiResult(response);
          if (parsed.success) {
            row.isNew = false;
            row._rowEdited = false;
            row.original = { subDevArea: row.subDevArea, padName: [...(row.padName || [])] };
            successCount++;
          } else {
            failureCount++;
            errorMessages.push(parsed.message || 'Unknown error occurred');
          }
          pendingCount--;
          if (pendingCount === 0) {
            this.loadSubDevAreaData(0);
            if (successCount > 0) {
              this.toastr.success(`${successCount} Sub-Dev row(s) saved successfully`, 'Success');
            }
            if (failureCount > 0) {
              const detailedErrorMsg = errorMessages.length > 0
                ? errorMessages.join('<br>')
                : `${failureCount} Sub-Dev row(s) failed to save`;
              this.toastr.error(detailedErrorMsg, 'Save Error', {
                timeOut: 8000,
                enableHtml: true
              });
            }
          }
        },
        (error: any) => {
          const parsed = ErrorHandler.parseApiResult(error);
          failureCount++;
          errorMessages.push(parsed.message || 'Unknown error occurred');
          pendingCount--;
          if (pendingCount === 0) {
            this.loadSubDevAreaData(0);
            if (successCount > 0) {
              this.toastr.success(`${successCount} Sub-Dev row(s) saved successfully`, 'Success');
            }
            if (failureCount > 0) {
              const detailedErrorMsg = errorMessages.length > 0
                ? errorMessages.join('<br>')
                : `${failureCount} Sub-Dev row(s) failed to save`;
              this.toastr.error(detailedErrorMsg, 'Save Error', {
                timeOut: 8000,
                enableHtml: true
              });
            }
          }
        }
      );
    });
  }

  handleFacilityNameChange(event: any, row: any): void {
    if (event.target.value === 'add-new') {
      if (!this.canAddNewFacility(row)) {
        row.facilityName = '';
        return;
      }
      row.facilityName = '';
      this.openAddOptionPopup(row, 'facilityName');
    }
  }

  isFacilityNameEditable(row: any): boolean {
    if (row?.isNew) {
      return true;
    }

    const facilityType = (row?.facilityType || '').trim().toLowerCase();

    return !['ctb', 'satelite', 'sateelite', 'satellite'].includes(
      facilityType
    );
  }

  canAddNewFacility(row: any): boolean {
    const facilityType = (row?.facilityType || '').trim().toLowerCase();

    return !['ctb', 'satelite', 'sateelite', 'satellite'].includes(
      facilityType
    );
  }

  private normalizeFacilityType(value: unknown): string {
    return String(value ?? '').trim().toLowerCase();
  }

  private isCdpFacilityType(value: unknown): boolean {
    return this.normalizeFacilityType(value) === 'cdp';
  }

  shouldDisableOilTakeAway(row: any): boolean {
    const facilityType = this.normalizeFacilityType(row?.facilityType);
    return facilityType === 'cdp' || facilityType === 'gas plant';
  }

  shouldDisableGasTakeAway(row: any): boolean {
    return this.normalizeFacilityType(row?.facilityType) === 'ctb';
  }

  handleOilTakeAwayChange(event: any, row: any): void {
    if (event.target.value === 'add-new') {
      row.oilTakeAway = '';
      this.openAddOptionPopup(row, 'oilTakeAway');
    }
  }

  handleGasTakeAwayChange(event: any, row: any): void {
    if (event.target.value === 'add-new') {
      row.gasTakeAway = '';
      this.openAddOptionPopup(row, 'gasTakeAway');
    }
  }

  showAddOptionModal: boolean = false;
  newOptionValue: string = '';
  addOptionLabel: string = 'Value';
  private addOptionTargetRow: any = null;
  private addOptionTargetField: 'facilityName' | 'oilTakeAway' | 'gasTakeAway' | null = null;

  openAddOptionPopup(row: any, field: 'facilityName' | 'oilTakeAway' | 'gasTakeAway'): void {
    this.addOptionTargetRow = row;
    this.addOptionTargetField = field;
    this.newOptionValue = '';
    this.addOptionLabel =
      field === 'facilityName'
        ? 'Facility Name'
        : field === 'oilTakeAway'
          ? 'Oil Take Away'
          : 'Gas Takeaway';
    this.showAddOptionModal = true;
  }

  confirmAddOption(): void {
    const newValue = (this.newOptionValue || '').trim();
    if (!newValue || !this.addOptionTargetField) {
      this.toastr.info(`Please enter ${this.addOptionLabel.toLowerCase()}.`);
      return;
    }

    if (this.addOptionTargetField === 'facilityName') {
      if (!this.facilityNameOptions.includes(newValue)) {
        this.facilityNameOptions.push(newValue);
      }
      if (this.addOptionTargetRow) {
        this.addOptionTargetRow.facilityName = newValue;
      }
    } else if (this.addOptionTargetField === 'oilTakeAway') {
      if (!this.oilTakeAwayOptions.includes(newValue)) {
        this.oilTakeAwayOptions.push(newValue);
      }
      if (this.addOptionTargetRow) {
        this.addOptionTargetRow.oilTakeAway = newValue;
      }
    } else if (this.addOptionTargetField === 'gasTakeAway') {
      if (!this.gasTakeAwayOptions.includes(newValue)) {
        this.gasTakeAwayOptions.push(newValue);
      }
      if (this.addOptionTargetRow) {
        this.addOptionTargetRow.gasTakeAway = newValue;
      }
    }

    this.toastr.success(`New ${this.addOptionLabel.toLowerCase()} added successfully.`);
    this.closeAddOptionPopup();
  }

  closeAddOptionPopup(): void {
    this.showAddOptionModal = false;
    this.newOptionValue = '';
    this.addOptionTargetRow = null;
    this.addOptionTargetField = null;
    this.addOptionLabel = 'Value';
  }

  loadTableData(lastRowNumber: number = 0) {
    const filters: adminTableData = {
      developmentArea:this.multiFilters['devArea'] && this.multiFilters['devArea'].length > 0? this.multiFilters['devArea'].join(','): null,
      facilityName:this.multiFilters['facilityName'] &&this.multiFilters['facilityName'].length > 0? this.multiFilters['facilityName'].join(',') : null,
      facilityType:this.multiFilters['facilityType'] &&this.multiFilters['facilityType'].length > 0? this.multiFilters['facilityType'].join(','): null,
      oilTakeAway:this.multiFilters['oilTakeAway'] &&this.multiFilters['oilTakeAway'].length > 0 ? this.multiFilters['oilTakeAway'].join(',') : null,
      gasTakeAway:this.multiFilters['gasTakeAway'] &&this.multiFilters['gasTakeAway'].length > 0 ? this.multiFilters['gasTakeAway'].join(',') : null,
      priority:this.multiFilters['priority'] && this.multiFilters['priority'].length > 0 ? Number(this.multiFilters['priority'][0]) : null,
      lastRowNumber: lastRowNumber,
    };
    this.gasPlantAdminService.getTableData(filters).subscribe((response: any) => {
      const parsed = ErrorHandler.parseApiResult(response);
      if (parsed.success) {
          const mappedData = response.gasItems.map((item: any) => ({
            ...item,
            devArea: item.developmentArea,
            oilTakeAway: item.oilTakeAway ?? item.oilTakeaway ?? item.OilTakeAway ?? item.OilTakeaway ?? '',
            gasTakeAway: item.gasTakeAway ?? item.gasTakeaway ?? item.GasTakeAway ?? item.GasTakeaway ?? '',
            originalFacilityName: item.facilityName,
            originalPriority: item.priority,
          }));
          this.data =lastRowNumber === 0 ? mappedData : [...this.data, ...mappedData];
          if (response.nextRowNumber) {
            this.loadTableData(response.nextRowNumber);
          }
        } else {
        }
      },
      (error) => {
        ErrorHandler.handleError(error, 'loadTableData');
      }
    );
  }


  openFloatingFilter(event: MouseEvent, column: string) {
    this.activeFilter = column;
    this.activeFilterTable = 'admin';
    this.showFloatingFilter = true;
    this.isLoadingFilterOptions = true;
    const targetEl = (event.currentTarget as HTMLElement) || (event.target as HTMLElement);
    const rect = targetEl.getBoundingClientRect();
    this.dropdownPosition = { top: rect.bottom + 6, left: rect.left + 2 };
    this.onFilterIconClick();
    if (this.filterOutsideClickHandler) {
      document.removeEventListener('click', this.filterOutsideClickHandler);
      this.filterOutsideClickHandler = null;
    }
    const closeFilter = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const filterBox = document.querySelector('.floating-filter-dropdown');
      if (filterBox && !filterBox.contains(target)) {
        this.showFloatingFilter = false;
        this.activeFilterTable = null;
        if (this.filterOutsideClickHandler) {
          document.removeEventListener('click', this.filterOutsideClickHandler);
          this.filterOutsideClickHandler = null;
        }
      }
    };
    this.filterOutsideClickHandler = closeFilter;
    setTimeout(() => document.addEventListener('click', this.filterOutsideClickHandler));
  }

  openSubDevFloatingFilter(event: MouseEvent, column: string) {
    this.activeFilter = column;
    this.activeFilterTable = 'subDev';
    this.showFloatingFilter = true;
    const targetEl = (event.currentTarget as HTMLElement) || (event.target as HTMLElement);
    const rect = targetEl.getBoundingClientRect();
    this.dropdownPosition = { top: rect.bottom + 6, left: rect.left + 2 };
    if (this.filterOutsideClickHandler) {
      document.removeEventListener('click', this.filterOutsideClickHandler);
      this.filterOutsideClickHandler = null;
    }
    const closeFilter = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const filterBox = document.querySelector('.floating-filter-dropdown');
      if (filterBox && !filterBox.contains(target)) {
        this.showFloatingFilter = false;
        this.activeFilterTable = null;
        if (this.filterOutsideClickHandler) {
          document.removeEventListener('click', this.filterOutsideClickHandler);
          this.filterOutsideClickHandler = null;
        }
      }
    };
    this.filterOutsideClickHandler = closeFilter;
    setTimeout(() => document.addEventListener('click', this.filterOutsideClickHandler));
    this.loadSubDevAreaFilterOptions(column, true);
  }

  private normalizeColumnName(name: string): string {
    return (name || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  private toStringList(values: any): string[] {
    if (!Array.isArray(values)) {
      return [];
    }
    return values.map((v: any) => String(v ?? '').trim());
  }

  private updateAdminFilterOptions(response: any): void {
    const items: any[] = Array.isArray(response)
      ? response
      : response?.adminColumnFilterItems || response?.columnFilterItems || response?.filterItems || [];

    if (!Array.isArray(items)) {
      return;
    }

    items.forEach((column: any) => {
      const key = this.normalizeColumnName(column?.columnName || column?.ColumnName || '');
      const values = this.toStringList(column?.values ?? column?.Values ?? []);

      if (key === 'developmentarea' || key === 'devarea') {
        this.devAreaOptions = values.filter(Boolean);
      } else if (key === 'facilityname') {
        this.facilityNameOptions = values.filter(Boolean);
      } else if (key === 'facilitytype') {
        this.facilityTypeOptions = values.filter(Boolean);
      } else if (key === 'oiltakeaway') {
        this.oilTakeAwayOptions = this.normalizeFilterOptionList(values);
      } else if (key === 'gastakeaway') {
        this.gasTakeAwayOptions = this.normalizeFilterOptionList(values);
      } else if (key === 'priority') {
        this.priorityOptions = values
          .map((v: string) => Number(v))
          .filter((v: number) => !Number.isNaN(v));
      }
    });
  }

  loadSubDevAreaFilterOptions(column: string, force: boolean = false) {
    if (!force && this.activeFilterTable !== 'subDev') {
      return;
    }
    if (this.isLoadingSubDevFilterOptions) return;
    this.isLoadingSubDevFilterOptions = true;
    const filters: subDevAreaFilterDropdowns = {
      developmentArea: this.subDevMultiFilters['devArea'] && this.subDevMultiFilters['devArea'].length ? this.subDevMultiFilters['devArea'].join(',') : null,
      subDevAreaName: this.subDevMultiFilters['subDevArea'] && this.subDevMultiFilters['subDevArea'].length ? this.subDevMultiFilters['subDevArea'].join(',') : null,
      padName: this.subDevMultiFilters['padName'] && this.subDevMultiFilters['padName'].length ? this.subDevMultiFilters['padName'].join('-') : null,
    };
    this.gasPlantAdminService.getSubDevAreaFilterDropdownOptions(filters).subscribe((response: any) => {
          this.subDevAreaOptions = [];
          this.padNameOptions = [];
          this.devAreaOptions = [];
          if (response) {
            if (Array.isArray(response)) {
              response.forEach((col: any) => {
                const vals = Array.isArray(col.values)? col.values.map((v: any) => String(v)): [];
                if (col.columnName === 'SubDevAreaName' || col.columnName === 'SubDevArea') {
                  this.subDevAreaOptions = vals;
                } else if (col.columnName === 'PadName') {this.padNameOptions = vals;
                } else if (col.columnName === 'DevelopmentArea' ||col.columnName === 'DevArea') {
                  this.devAreaOptions = vals;
                }
              });
            } else if (response.subDevAreaColumnFilterItems) {
              response.subDevAreaColumnFilterItems.forEach((col: any) => {
                const vals = Array.isArray(col.values)? col.values.map((v: any) => String(v)): [];
                if (col.columnName === 'SubDevAreaName' || col.columnName === 'SubDevArea'
                ) {this.subDevAreaOptions = vals;
                } else if (col.columnName === 'PadName') {this.padNameOptions = vals;
                } else if (col.columnName === 'DevelopmentArea' ||col.columnName === 'DevArea'
                ) {this.devAreaOptions = vals;
                }
              });
            } else if (response.subDevAreaFilter) {
              response.subDevAreaFilter.forEach((col: any) => {
                const vals = Array.isArray(col.values)? col.values.map((v: any) => String(v)): [];
                if (col.columnName === 'SubDevArea' ||col.columnName === 'SubDevAreaName'
                ) {
                  this.subDevAreaOptions = vals;
                } else if (col.columnName === 'PadName') {
                  this.padNameOptions = vals;
                } else if (col.columnName === 'DevelopmentArea' || col.columnName === 'DevArea'
                ) {
                  this.devAreaOptions = vals;
                }
              });
            }
          }
          this.isLoadingSubDevFilterOptions = false;
          this.isLoadingFilterOptions = false;
        },
        (error: any) => {
          this.isLoadingSubDevFilterOptions = false;
          this.isLoadingFilterOptions = false;
          ErrorHandler.handleError(error, 'loadSubDevAreaFilterOptions');
        }
      );
  }

  onFilterIconClick() {
    const filters: adminDropdownFilters = {
      developmentArea:this.multiFilters['devArea'] && this.multiFilters['devArea'].length > 0? this.multiFilters['devArea'].join(','): null,
      facilityName:this.multiFilters['facilityName'] &&this.multiFilters['facilityName'].length > 0 ? this.multiFilters['facilityName'].join(',') : null,
      facilityType:this.multiFilters['facilityType'] &&this.multiFilters['facilityType'].length > 0? this.multiFilters['facilityType'].join(','): null,
      oilTakeAway:this.multiFilters['oilTakeAway'] &&this.multiFilters['oilTakeAway'].length > 0 ? this.multiFilters['oilTakeAway'].join(',') : null,
      gasTakeAway:this.multiFilters['gasTakeAway'] &&this.multiFilters['gasTakeAway'].length > 0 ? this.multiFilters['gasTakeAway'].join(',') : null,
      priority:this.multiFilters['priority'] && this.multiFilters['priority'].length > 0 ? Number(this.multiFilters['priority'][0]) : null,
    };

    this.isLoadingFilterOptions = true;
    this.gasPlantAdminService.getFilterDropdownOptions(filters).subscribe(
      (response: any) => {
        this.updateAdminFilterOptions(response);
        this.isLoadingFilterOptions = false;
      },
      (error) => {
        this.isLoadingFilterOptions = false;
        ErrorHandler.handleError(error, 'onFilterIconClick');
      }
    );
  }

  isChecked(field: string, value: string): boolean {
    if (this.activeFilterTable === 'subDev') {
      return this.subDevMultiFilters[field]?.includes(value) || false;
    }
    return this.multiFilters[field]?.includes(value) || false;
  }

  toggleMultiFilter(field: string, value: string, event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    const targetFilters = this.activeFilterTable === 'subDev' ? this.subDevMultiFilters : this.multiFilters;
    if (!targetFilters[field]) {
      targetFilters[field] = [];
    }
    if (checked) {
      targetFilters[field].push(value);
    } else {
      targetFilters[field] = targetFilters[field].filter((v: string) => v !== value);
    }
  }

  applyFilter(field: string): void {
    const filters: adminDropdownFilters = {
      developmentArea: this.multiFilters['devArea'] && this.multiFilters['devArea'].length > 0 ? this.multiFilters['devArea'].join(','): null,
      facilityName: this.multiFilters['facilityName'] && this.multiFilters['facilityName'].length > 0? this.multiFilters['facilityName'].join(',') : null,
      facilityType:this.multiFilters['facilityType'] &&this.multiFilters['facilityType'].length > 0? this.multiFilters['facilityType'].join(','): null,
      oilTakeAway:this.multiFilters['oilTakeAway'] &&this.multiFilters['oilTakeAway'].length > 0 ? this.multiFilters['oilTakeAway'].join(',') : null,
      gasTakeAway:this.multiFilters['gasTakeAway'] &&this.multiFilters['gasTakeAway'].length > 0 ? this.multiFilters['gasTakeAway'].join(',') : null,
      priority:this.multiFilters['priority'] && this.multiFilters['priority'].length > 0 ? Number(this.multiFilters['priority'][0]) : null,
    };
    this.isLoadingFilterOptions = true;
    this.gasPlantAdminService.getFilterDropdownOptions(filters).subscribe(
      (response: any) => {
        this.updateAdminFilterOptions(response);
        this.isLoadingFilterOptions = false;
        this.loadTableData(0);
        this.showFloatingFilter = false;
        this.activeFilterTable = null;
        if (this.filterOutsideClickHandler) {
          document.removeEventListener('click', this.filterOutsideClickHandler);
          this.filterOutsideClickHandler = null;
        }
      },
      (error) => {
        this.isLoadingFilterOptions = false;
        ErrorHandler.handleError(error, 'applyFilter');
      }
    );
  }

  applyFilterSubDev(field: string): void {
    const filters: any = {developmentArea: this.subDevMultiFilters['devArea'] && this.subDevMultiFilters['devArea'].length > 0 ? this.subDevMultiFilters['devArea'].join(',') : null,
      subDevAreaName: this.subDevMultiFilters['subDevArea'] && this.subDevMultiFilters['subDevArea'].length > 0 ? this.subDevMultiFilters['subDevArea'].join(',') : null,
      padName: this.subDevMultiFilters['padName'] && this.subDevMultiFilters['padName'].length > 0 ? this.subDevMultiFilters['padName'].join('-') : null,
    };
    this.isLoadingFilterOptions = true;
    this.isLoadingSubDevFilterOptions = true;
    this.gasPlantAdminService.getSubDevAreaFilterDropdownOptions(filters).subscribe((response: any) => {
          if (Array.isArray(response)) {
            response.forEach((col: any) => {
              if (col.columnName === 'DevelopmentArea')
                this.devAreaOptions = col.values || [];
              else if (col.columnName === 'PadName')
                this.padNameOptions = col.values || [];
              else if ( col.columnName === 'SubDevArea' || col.columnName === 'SubDevAreaName')
                this.subDevAreaOptions = col.values || [];
            });
          } else if (response && response.subDevAreaColumnFilterItems) {
            response.subDevAreaColumnFilterItems.forEach((col: any) => {
              if (col.columnName === 'DevelopmentArea')
                this.devAreaOptions = col.values || [];
              else if (col.columnName === 'PadName')
                this.padNameOptions = col.values || [];
              else if (col.columnName === 'SubDevArea' || col.columnName === 'SubDevAreaName')
                this.subDevAreaOptions = col.values || [];
            });
          }
          this.isLoadingFilterOptions = false;
          this.isLoadingSubDevFilterOptions = false;
          this.loadSubDevAreaData(0);
          this.showFloatingFilter = false;
          this.activeFilterTable = null;
          if (this.filterOutsideClickHandler) {
            document.removeEventListener('click', this.filterOutsideClickHandler);
            this.filterOutsideClickHandler = null;
          }
        },
        (error: any) => {
          this.isLoadingFilterOptions = false;
          this.isLoadingSubDevFilterOptions = false;
          ErrorHandler.handleError(error, 'applyFilterSubDev');
        }
      );
  }

  clearFilter(field: string): void {
    this.multiFilters[field] = [];
    this.showFloatingFilter = false;
    this.activeFilterTable = null;
    const filters: adminDropdownFilters = {
      developmentArea: null,
      facilityName: null,
      facilityType: null,
      oilTakeAway: null,
      gasTakeAway: null,
      priority: null,
    };
    this.isLoadingFilterOptions = true;
    this.gasPlantAdminService.getFilterDropdownOptions(filters).subscribe((response: any) => {
        this.updateAdminFilterOptions(response);
        this.isLoadingFilterOptions = false;
        this.loadTableData(0);
      },
      (error) => {
        this.isLoadingFilterOptions = false;
        ErrorHandler.handleError(error, 'clearFilter');
      }
    );
  }

  getFilterOptions(field: string): string[] {
    const searchValue: string = this.filterSearch[field]?.toLowerCase() || '';
    let allOptions: string[] = (this as any)[field + 'Options'] || [];
    if (field === 'subDevArea') {
      allOptions = this.subDevAreaOptions || [];
    } else if (field === 'padName') {
      allOptions = this.padNameOptions || [];
    } else if (field === 'priority') {
      allOptions = (this.priorityOptions || []).map((p: number) => String(p));
    }
    return allOptions.filter((option: string) =>
      this.getFilterOptionLabel(option).toLowerCase().includes(searchValue)
    );
  }

  getFilterOptionLabel(option: string): string {
    return this.isBlankFilterValue(option) ? '(Blank)' : option;
  }

  applyFilterClick(): void {
    const f = this.activeFilter;
    if (this.activeFilterTable === 'subDev') {
      this.applyFilterSubDev(f);
    } else {
      this.applyFilter(f);
    }
  }

  clearFilterClick(): void {
    const f = this.activeFilter;
    if (this.activeFilterTable === 'subDev') {
      this.subDevMultiFilters[f] = [];
      this.applyFilterSubDev(f);
    } else {
      this.multiFilters[f] = [];
      this.clearFilter(f);
    }
  }

  hasAdminFiltersApplied(): boolean {
    return Object.values(this.multiFilters).some(
      (values) => Array.isArray(values) && values.length > 0
    );
  }

  hasSubDevFiltersApplied(): boolean {
    return Object.values(this.subDevMultiFilters).some(
      (values) => Array.isArray(values) && values.length > 0
    );
  }

  isAdminFilterActive(field: string): boolean {
    return (this.multiFilters[field] || []).length > 0;
  }

  isSubDevFilterActive(field: string): boolean {
    return (this.subDevMultiFilters[field] || []).length > 0;
  }

  clearAllAdminFilters(): void {
    this.multiFilters = {};
    this.showFloatingFilter = false;
    this.activeFilterTable = null;

    const filters: adminDropdownFilters = {
      developmentArea: null,
      facilityName: null,
      facilityType: null,
      oilTakeAway: null,
      gasTakeAway: null,
      priority: null,
    };

    this.isLoadingFilterOptions = true;
    this.gasPlantAdminService.getFilterDropdownOptions(filters).subscribe(
      (response: any) => {
        this.updateAdminFilterOptions(response);
        this.isLoadingFilterOptions = false;
        this.loadTableData(0);
      },
      (error) => {
        this.isLoadingFilterOptions = false;
        ErrorHandler.handleError(error, 'clearAllAdminFilters');
      }
    );
  }

  clearAllSubDevFilters(): void {
    this.subDevMultiFilters = {};
    this.showFloatingFilter = false;
    this.activeFilterTable = null;

    this.loadSubDevAreaFilterOptions('devArea', true);
    this.loadSubDevAreaData(0);
  }

  openAdminExportDialog(): void {
    this.dialog.open(this.adminExportOptionsDialog, {
      width: '380px',
      disableClose: true,
    });
  }

  openSubDevExportDialog(): void {
    this.dialog.open(this.subDevExportOptionsDialog, {
      width: '380px',
      disableClose: true,
    });
  }

  async exportCSV(): Promise<void> {
    if (!this.data.length) {
      this.toastr.info('No data available to export.');
      return;
    }

    const adminHeaders = ['Dev Area', 'Facility Type', 'Facility Name', 'Oil TakeAway', 'Gas TakeAway', 'Priority'];
    const worksheetData = this.data.map((row) => ({
      'Dev Area': row.devArea ?? '',
      'Facility Type': row.facilityType ?? '',
      'Facility Name': row.facilityName ?? '',
      'Oil TakeAway': row.oilTakeAway ?? '',
      'Gas TakeAway': row.gasTakeAway ?? '',
      Priority: row.priority ?? '',
    }));

    await exportRowsToExcel(
      worksheetData,
      adminHeaders,
      'gas-plant-mapping.xlsx',
      'GasPlantMapping'
    );
  }

  async downloadAllAdminData(): Promise<void> {
    try {
      const { blob, fileName } = await this.gasPlantAdminService.exportAllOilAndGasAdminData();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(url);
      this.toastr.success('Export downloaded successfully.');
    } catch (error: any) {
      this.toastr.error(error?.message || 'Failed to download export.');
    }
  }

  async exportSubDevCSV(): Promise<void> {
    if (!this.dataSubDevArea.length) {
      this.toastr.info('No data available to export.');
      return;
    }

    const subDevHeaders = ['Dev Area', 'Sub Dev Area', 'Pad Name'];
    const worksheetData = this.dataSubDevArea.map((row) => ({
      'Dev Area': row.devArea ?? '',
      'Sub Dev Area': row.subDevArea ?? '',
      'Pad Name': Array.isArray(row.padName) ? row.padName.join('; ') : row.padName ?? '',
    }));

    await exportRowsToExcel(
      worksheetData,
      subDevHeaders,
      'sub-dev-area-mapping.xlsx',
      'SubDevAreaMapping'
    );
  }

  async downloadAllSubDevAreaData(): Promise<void> {
    try {
      const { blob, fileName } = await this.gasPlantAdminService.exportAllOilAndGasSubDevAreaData();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(url);
      this.toastr.success('Export downloaded successfully.');
    } catch (error: any) {
      this.toastr.error(error?.message || 'Failed to download export.');
    }
  }
}
